import React from 'react'
import CardNew from 'presentation/shared/components/CardNew'
import * as S from './styles'
import { TooltipNew } from 'presentation/shared/components/TooltipNew'

interface ComparisonCardProps {
  icon: React.ReactNode
  title: string
  value: number | string
  variant:
    | 'positive'
    | 'negative'
    | 'equal'
    | 'indicatorPositive'
    | 'indicatorNegative'
    | 'indicatorEqual'
    | 'noData'
}

export const ComparisonCard = ({
  icon,
  title,
  value,
  variant
}: ComparisonCardProps) => {
  const hasNoData = variant === 'noData'

  return (
    <CardNew
      background="neutral25"
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: '8px',
        alignItems: 'center',
        width: '100%',
        minHeight: '120px'
      }}
    >
      {icon}
      <S.ComparisonTitle>{title}</S.ComparisonTitle>
      {hasNoData ? (
        <TooltipNew
          text="Ainda não há informações relacionadas a este indicador"
          className="icon"
          type="neutral"
        >
          <S.ComparisonValue variant={variant}>{value}</S.ComparisonValue>
        </TooltipNew>
      ) : (
        <S.ComparisonValue variant={variant}>
          {Number(value) > 0 ? '+' : ''}
          {parseFloat(Number(value).toFixed(2))}%
        </S.ComparisonValue>
      )}
    </CardNew>
  )
}
